import { TextareaHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...rest }, ref) => (
    <textarea ref={ref} className={clsx('w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary', className)} {...rest} />
  ),
);
Textarea.displayName = 'Textarea';
